module.exports = __webpack_public_path__ + "img/leftbicep-endomorph-female.3fc2e7ba.svg";